<template>
  <div class="alert__container">
    <div v-if="show" class="mds-alert mds-alert--success mds-alert--dismissible" role="alertdialog">
      <div class="mds-alert__cell-icon">
        <svg class="mds-icon mds-alert__icon" aria-hidden="true">
          <use xlink:href="static/mds/icons/mds.svg#check"></use>
        </svg>
      </div>
      <div class="mds-alert__cell-body">
        <aside class="mds-alert__content">
          <strong class="mds-alert__title">{{ title }}</strong>
          <p v-if="message" class="mds-alert__message">{{ message }}</p>
        </aside>
      </div>
      <button
        class="mds-button mds-button--small mds-button--icon-only mds-alert__dismiss-button"
        type="button"
        @click="closeAlert"
      >
        <svg class="mds-icon mds-button__icon mds-button__icon--right" aria-hidden="true">
          <use xlink:href="static/mds/icons/mds.svg#remove--s"></use>
        </svg>
      </button>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
  name: 'Alert',
  computed: {
    ...mapState({
      show: (state) => state.alert.show,
      title: (state) => state.alert.settings.title,
      message: (state) => state.alert.settings.message,
    }),
  },
  methods: {
    ...mapActions({
      closeAlert: 'closeAlert',
      openAlert: 'openAlert',
    }),
  },
};
</script>
<style>
.alert__container {
  position: absolute;
  left: 30%;
  top: 8px;
  right: 30%;
}
</style>
